import React from "react";
import { TableCell, TableHead, TableRow, TableSortLabel, Tooltip } from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
    sortIconHidden: {
        "& .MuiSvgIcon-root" : {
            display: "none"
        },
        "&:hover": {
           color: "inherit"
        },
        "&:focus": {
            color: "inherit"
        }
    }
});

export interface HeadCell {
    label: string,
    property: string,
    sortable: boolean
}

export type SortingType = "asc" | "desc";

interface SortableTableHeadProps {
    columnHeads: Array<HeadCell>,
    sortType: SortingType,
    sortBy: string,
    onRequestSort: (property: string) => void   
}

/**
 * The Component is re-usable component, provide a basic sortable table head, the sortable column head has the tooltip and sort icon
 */
const SortableTableHead: React.FunctionComponent<SortableTableHeadProps> = (props: SortableTableHeadProps) => {
    const styles = useStyles();
    const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
        props.onRequestSort(property);
    };

    return (
        <TableHead>
            <TableRow>
                {props.columnHeads.map(header => 
                    <TableCell 
                        key={header.property}
                        sortDirection={props.sortBy === header.property ? props.sortType : false}>
                        <Tooltip title={header.sortable ? "sort" : ""} placement="bottom-end">
                            <TableSortLabel
                                className={header.sortable ? "" : styles.sortIconHidden}
                                active={props.sortBy === header.property}
                                direction={props.sortBy === header.property ? props.sortType : "desc"}
                                onClick={createSortHandler(header.property)}>
                                {header.label}
                            </TableSortLabel>
                        </Tooltip>
                    </TableCell>
                )}
            </TableRow>
        </TableHead>
    );
}

export default SortableTableHead;